import { Factory } from '../../services/Factory';

namespace app.directives.charting {


  interface IProgressMeterScope extends angular.IScope {
    score: number;
  }

  interface IProgressMeterAttributes extends angular.IAttributes {

  }

  export class ProgressMeter implements angular.IDirective {
    public restrict: string = 'E';
    public link: (scope: IProgressMeterScope, element: angular.IAugmentedJQuery, attrs: IProgressMeterAttributes) => void;
    public template: string;
    public scope = {score: '=ngModel'};
    public require = ['ngModel'];

    constructor() {
      this.template = "<div/>";
      this.link = (scope: IProgressMeterScope, element: angular.IAugmentedJQuery, attrs: IProgressMeterAttributes) => {
        let width = 60,
          height = 60,
          twoPi = 2 * Math.PI,
          progress = 0,
          formatPercent = d3.format(".0%");

        let arc = d3.arc()
          .startAngle(0)
          .innerRadius(28.3)
          .outerRadius(29);

        let svg = d3.select(element[0]).append("svg")
          .attr("width", width)
          .attr("height", height)
          .append("g")
          .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

        let meter = svg.append("g")
          .attr("class", "progress-meter");

        meter.append("path")
          .attr("class", "background")
          .attr("d", arc.endAngle(twoPi));

        let foreground = meter.append("path")
          .attr("class", "foreground");

        let text = meter.append("text")
          .attr("text-anchor", "middle")
          .attr("dy", ".35em");

        foreground.attr("d", arc.endAngle(twoPi * (scope.score / 100)));
        text.text(formatPercent(scope.score / 100));
      }
    }
  }

  frontendApp.directive("iioProgressMeter", [Factory.Create(ProgressMeter)]);
}
